import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from "react-router-dom";
import { HashRouter } from "react-router-dom";
import { MoralisProvider } from "react-moralis";



ReactDOM.render(
  <React.StrictMode>
    {/* <MoralisProvider appId="w1cag2MIVxTsOh4GxoqbMnSDAHupEbTIN7w8SKqv" serverUrl="https://tlfacj3dnlla.usemoralis.com:2053/server" > */}
    <MoralisProvider appId="ctnKbOzNhleZpkQ507O3jmbD2ZibX5wpLUyUhcQn" serverUrl="https://gfgk4ozhkz0r.usemoralis.com:2053/server">

      {/* <BrowserRouter> */}
      <HashRouter>
        <App />
      </HashRouter>
      {/* </BrowserRouter> */}
    </MoralisProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
